import Vue from 'vue'
// eslint-disable-next-line no-unused-vars
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
// eslint-disable-next-line no-unused-vars
import CurrencyInput from '@/components/ui/currencyInput'
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
// eslint-disable-next-line no-unused-vars
import VxCurrencyInput from '@/components/ui/VxCurrencyInput'
import IconSvg from '@/components/IconSvg/index.vue'
import moment from 'moment'

const cellRenderParamsConfig = Vue.extend({
  data() {
    return {
      active: false,
      breakfastTime: '08:30 -09:00',
      balanceCodeOptions: [
        {
          value: 'a',
          label: 'A'
        },
        {
          value: 'b',
          label: 'B'
        },
        {
          value: 'c',
          label: 'C'
        },
        {
          value: 'd',
          label: 'D'
        },
        {
          value: 'l',
          label: 'L'
        }
      ],
      whPoPricePrecisionOptions: [
        {
          value: 0,
          label: '0'
        },
        {
          value: 1,
          label: '1'
        },
        {
          value: 2,
          label: '2'
        },
        {
          value: 3,
          label: '3'
        }
      ],
      whPoTotalAmountPrecisionOptions: [
        {
          value: 0,
          label: '0'
        },
        {
          value: 1,
          label: '1'
        },
        {
          value: 2,
          label: '2'
        }
      ],
      value: ''
    }
  },
  beforeMount() {
    if (this.params) this.active = this.params.active
    this.value = this.params.value
  },
  methods: {
    changeInput() {
      this.params.context.componentParent.changeInput(
        this.params.data.id,
        this.value
      )
    }
  },
  template: `
  <div style="width: 100%; text-align: center" class="config-params-modified">
    <div v-if="params.data.id == 1" class="checkbox-wrap">
      <input
        id="cpSpdTp1"
        v-model="value"
        type="checkbox"
        @change="changeInput"
      />
      <label for="cpSpdTp1"></label>
    </div>
    <input class="input-text-border-none" type="text" v-if="params.data.id == 2" @blur="changeInput" v-model="value" />
    <el-select size="mini" v-if="params.data.id == 3" @change="changeInput" v-model="value" style="width: 100%;">
      <el-option v-for="item in balanceCodeOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value"></el-option>
    </el-select>
    <div v-if="params.data.id == 4" class="checkbox-wrap">
      <input
        id="cpSpdTp2"
        v-model="value"
        type="checkbox"
        @change="changeInput"
      />
      <label for="cpSpdTp2"></label>
    </div>
    <input class="input-text-border-none" type="text" v-if="params.data.id == 5" @blur="changeInput" v-model="value" />
    <div v-if="params.data.id == 6" class="checkbox-wrap">
      <input
        id="cpSpdTp2"
        v-model="value"
        type="checkbox"
        @change="changeInput"
      />
      <label for="cpSpdTp2"></label>
    </div>
    <div v-if="params.data.id == 7" class="checkbox-wrap">
      <input
        id="cpSpdTp2"
        v-model="value"
        type="checkbox"
        @change="changeInput"
      />
      <label for="cpSpdTp2"></label>
    </div>
    <el-select size="mini" v-if="params.data.id == 8" @change="changeInput" v-model="value" style="width: 100%;">
      <el-option v-for="item in whPoPricePrecisionOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value"></el-option>
    </el-select>
    <el-select size="mini" v-if="params.data.id == 9" @change="changeInput" v-model="value" style="width: 100%;">
      <el-option v-for="item in whPoTotalAmountPrecisionOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value"></el-option>
    </el-select>
    <div v-if="params.data.id == 10" class="checkbox-wrap">
      <input
        id="cpSpdTp2"
        v-model="value"
        type="checkbox"
        @change="changeInput"
      />
      <label for="cpSpdTp2"></label>
    </div>
  </div>
  `
})

const CellRenderToggleSwitchReadOnly = Vue.extend({
  data() {
    return {
      active: false
    }
  },
  beforeMount() {
    if (this.params) this.active = this.params.active
  },
  methods: {},
  template: `
  <el-switch
    v-model="active"
    active-color="#399f6e"
    inactive-color="#CAC9C9"
    disabled
    style="opacity: 1 !important"
  >
  </el-switch>
  `
})
const CellRenderToggleSwitch = Vue.extend({
  data() {
    return {
      active: false
    }
  },
  beforeMount() {
    if (this.params) this.active = this.params.active
  },
  methods: {
    changeInput() {
      this.params.context.componentParent.togglePackageCategory(this.params)
    }
  },
  template: `
  <label class="switch">
    <input type="checkbox" :checked="active" :value="active" @change="changeInput">
    <span class="slider round"></span>
  </label>
  `
})
const CellRenderNumberInputBySum = Vue.extend({
  data() {
    return {
      value: null,
      sum: null,
      colName: null,
      flagSave: true,
      disabled: false
    }
  },
  watch: {
    value() {}
  },
  beforeMount() {
    if (
      this.params?.stringValue !== null &&
      this.params?.stringValue !== undefined
    ) {
      const stringValue = this.params.stringValue
      const arrayValue = stringValue.split('/')
      this.value = +arrayValue[0]
      this.sum = +arrayValue[1]
    }

    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
    this.params.disabled ? (this.disabled = this.params.disabled) : false
  },

  methods: {
    changeInput() {
      if (this.value > this.sum) {
        const stringValue = this.params.stringValue
        const arrayValue = stringValue.split('/')
        this.value = +arrayValue[0]
        this.$message({
          message: 'Giá trị vượt quá giá trị lớn nhất',
          type: 'error'
        })
        this.flagSave = false
        this.params.context.componentParent.numberInputBySumChange(
          this.params,
          +this.value,
          this.sum,
          this.colName,
          this.flagSave
        )
      } else {
        this.flagSave = true
        this.params.context.componentParent.numberInputBySumChange(
          this.params,
          +this.value,
          this.sum,
          this.colName,
          this.flagSave
        )
      }
    }
  },
  template: `
  <div style="display: flex; align-items: center">
    <input class="input-text-border-none" min='0' :disabled='disabled' type="number" v-model="value" v-numeric-only @blur="changeInput" style="width: 40px">
    <span>/{{sum}} </span>
  </div>
  `
})

const CellRenderColorPicker = Vue.extend({
  data() {
    return {
      color: ''
    }
  },
  beforeMount() {
    if (this.params) this.color = this.params.color
  },
  methods: {
    onClick() {
      return false
    }
  },
  template: `
  <div style="display: flex; justify-content: center;">
    <div style="width: 30px; height: 30px; border-radius: 5px" :style="{ 'background-color': color }"></div>
  </div>
  `
})

const CellRenderCheckbox = Vue.extend({
  data() {
    return {
      value: false,
      colName: null,
      id: 'slcrd' + Math.floor(Math.random() * 100000)
    }
  },
  beforeMount() {
    if (this.params) this.value = this.params.value
    this.params.colName ? (this.colName = this.params.colName) : null
  },
  methods: {
    changeInput() {
      this.params.context.componentParent.changeCheckbox(
        this.colName,
        this.params,
        this.value
      )
    }
  },
  template: `
  <div class="checkbox-wrap"
    style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;"
  >
    <input
      :id="id"
      v-model="value"
      :checked="value"
      type="checkbox"
      @change="changeInput()"
    />
    <label :for="id" />
  </div>
  `
})

const CellRenderCheckboxReadonly = Vue.extend({
  data() {
    return {
      value: false
    }
  },
  beforeMount() {
    if (this.params) this.value = this.params.value
  },
  methods: {
    onClick(e) {
      e.stopPropagation()

      return false
    }
  },
  template: `
    <div class="flex align-center" style="height: 100%">
      <div class="cell-renderer-checkbox__readonly" :class="{ 'checked': value }"></div>
    </div>
  `
})

const CellRenderEditIcon = Vue.extend({
  data() {
    return {
      value: false
    }
  },
  beforeMount() {
    if (this.params) this.value = this.params.value
  },
  methods: {
    onIconClicked() {
      this.params.context.componentParent.onIconClicked(this.params)
    }
  },
  template: `
  <div style="display: flex; justify-content: center;">
    <i style="cursor: pointer;" class="el-icon-edit" @click="onIconClicked"></i>
  </div>
  `
})

const CellRenderOpenDialogWhenCLicked = Vue.extend({
  data() {
    return {
      // value: null
      clickable: false
    }
  },
  beforeMount() {
    // if (this.params) this.value = this.params.value
    this.clickable = !!(
      this.params.clickable || this.params?.clickable === undefined
    )
  },
  methods: {
    onClick() {
      // 1.GridName
      // 2.ColNm
      // 3.RowIdx
      this.params.context.componentParent.opendialogByCellRenderComp(
        this.params.refName,
        this.params.column.colId,
        this.params.rowIndex,
        this.params
      )
    }
  },
  template: `
    <span v-if="clickable" style="font-weight: 700; cursor: pointer; color: #357456" @click="onClick">{{this.params.value ?? null}}</span>
    <span v-else>{{this.params.value ?? null}}</span>
  `
})

const CellRenderDeleteIcon = Vue.extend({
  data() {
    return {
      value: false
    }
  },
  beforeMount() {
    if (this.params) this.value = this.params.value
  },
  methods: {
    onIconClicked() {
      this.params.context.componentParent.onDeleteIconClicked(this.params)
    }
  },
  // <i style="cursor: pointer;" class="el-icon-delete-solid" @click="onIconClicked"></i>
  template: `
  <div style="display: flex; justify-content: center; align-items: center; gap: 5px; cursor: pointer; height: 100%; align-items: center">

    <svg style="cursor: pointer;"  @click="onIconClicked" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9 1H15C16.1046 1 17 1.89543 17 3V4H20C21.1046 4 22 4.89543 22 6V8C22 9.10457 21.1046 10 20 10H19.9199L19 21C19 22.1046 18.1046 23 17 23H7C5.89543 23 5 22.1046 5.00345 21.083L4.07987 10H4C2.89543 10 2 9.10457 2 8V6C2 4.89543 2.89543 4 4 4H7V3C7 1.89543 7.89543 1 9 1ZM4 6H7H17H20V8H4V6ZM6.08649 10H17.9132L17.0035 20.917L17 21H7L6.08649 10ZM15 3V4H9V3H15Z" fill="#F12B37"/>
    </svg>
  </div>
  `
})

const CellHeaderAddIcon = Vue.extend({
  data() {
    return {
      value: false
    }
  },
  beforeMount() {
    if (this.params) this.value = this.params.value
  },
  methods: {
    onIconClicked() {
      this.params.context.componentParent.onAddRowInGrid(this.params)
    }
  },
  template: `
  <div style="display: flex; justify-content: center; align-items: center; gap: 5px; cursor: pointer;">
    <span @click="onIconClicked" style="color: #fff; font-size: 30px;">+</span>
  </div>
  `
})

const CellRenderSelect = Vue.extend({
  data() {
    return {
      value: '',
      // type: 'text',
      refName: null,
      options: []
    }
  },
  watch: {
    // value() {
    //   this.params.context.componentParent.textInputChange(
    //     this.params,
    //     this.value
    //   )
    // }
  },
  beforeMount() {
    if (this.params?.value) {
      this.value = this.params.value
    }
    this.params.refName ? (this.refName = this.params.refName) : null
    // this.params.type ? this.type = this.params.type : null
    this.params.options ? (this.options = this.params.options) : null
  },
  methods: {
    changeInput() {
      this.params.context.componentParent.SelectInputChange(
        this.refName,
        this.params,
        this.value
      )
    }
  },
  template: `
    <el-select
      v-model="value"
      placeholder=""
      size="small"
      @change="changeInput"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  `
})

const CellRenderTextInput = Vue.extend({
  data() {
    return {
      value: '',
      type: 'text',
      colName: null
    }
  },
  watch: {
    // value() {
    //   this.params.context.componentParent.textInputChange(
    //     this.params,
    //     this.value
    //   )
    // }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    this.params.type ? (this.type = this.params.type) : null
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
  },
  methods: {
    changeInput() {
      if (this.type === 'number') {
        this.params.context.componentParent.textInputChange(
          this.params,
          +this.value,
          this.colName
        )
      } else {
        this.params.context.componentParent.textInputChange(
          this.params,
          this.value,
          this.colName
        )
      }
    }
  },
  template: `<input class="input-text-border-none" min='0' :type="type" v-model="value" @blur="changeInput"/>`
})

const CellRenderTextInput2 = Vue.extend({
  data() {
    return {
      value: '',
      type: 'text',
      colName: null
    }
  },
  watch: {
    // value() {
    //   this.params.context.componentParent.textInputChange(
    //     this.params,
    //     this.value
    //   )
    // }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    this.params.type ? (this.type = this.params.type) : null
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
  },
  methods: {
    changeInput() {
      if (this.type === 'number') {
        this.params.context.componentParent.textInputChange2(
          this.params,
          +this.value,
          this.colName
        )
      } else {
        this.params.context.componentParent.textInputChange2(
          this.params,
          this.value,
          this.colName
        )
      }
    }
  },
  template: `<input class="input-text-border-none" min='0' :type="type" v-model="value" @blur="changeInput"/>`
})

const CellRenderDateTimeInput = Vue.extend({
  components: {
    CalendarSelect
  },
  data() {
    return {
      value: null,
      colName: null,
      date: {
        min: this.$moment().startOf('day').format('YYYY-MM-DD')
      },
      pickerOptions: null,
      clearable: false,
      dateType: 'date',
      format: 'dd/MM/yyyy HH:mm',
      valueFormat: 'yyyy-MM-dd HH:mm'
    }
  },
  mounted() {},
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = moment(this.params.value).toDate()
    }
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
    if (this.params.date !== null && this.params.date !== undefined) {
      this.date.min = moment(this.params.date.min).toDate()
      this.date.max = moment(this.params.date.max).toDate()
    } else {
      this.date = null
    }
    if (
      this.params.clearable !== null &&
      this.params?.clearable !== undefined
    ) {
      this.clearable = this.params.clearable
    }
    if (this.params.dateType !== null && this.params?.dateType !== undefined) {
      this.dateType = this.params.dateType
    }
    if (this.params.format !== null && this.params?.format !== undefined) {
      this.format = this.params.format
    }
    if (
      this.params.valueFormat !== null &&
      this.params?.valueFormat !== undefined
    ) {
      this.valueFormat = this.params.valueFormat
    }
    this.pickerOptions = { disabledDate: this.limitTime }
  },
  methods: {
    changeDateTime() {
      this.params.context.componentParent.changeDateTime(
        this.params,
        this.value,
        this.colName
      )
    },
    limitTime(time) {
      // console.log('hahaha', this.date)
      if (this.date !== null) {
        return time.getTime() < this.date.min || time.getTime() > this.date.max
      }
    }
    // onInput(val) {
    //   this.value = val
    // }
  },
  template: `
    <el-date-picker
      v-model="value"
      :type="dateType"
      placeholder=""
      :format='format'
      :value-format='valueFormat'
      size='large'
      :clearable="clearable"
      :picker-options="pickerOptions"
      @change="changeDateTime"
      popper-class="ag-cell-component__calendar-select"
    />
    
  `
})

const CellRenderControlNumber = Vue.extend({
  data() {
    return {
      value: 1,
      colName: null
    }
  },
  watch: {
    // value() {
    //   this.params.context.componentParent.textInputChange(
    //     this.params,
    //     this.value
    //   )
    // }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    this.params.type ? (this.type = this.params.type) : null
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
  },
  methods: {
    onChange() {
      this.params.context.componentParent.numberControllerChange(
        this.params,
        this.value,
        this.colName
      )
    },
    onSubstract() {
      if (this.value < 1) {
        return
      } else {
        this.value--
        this.onChange()
      }
    },
    onPlus() {
      this.value++
      this.onChange()
    }
  },
  template: `
  <div class="cell-renderer">
    <div class="number-controller">
      <div class="substract btn" @click="onSubstract">-</div>
      <div><input v-model="value" @change="onChange()"/></div>
      <div class="plus btn" @click="onPlus">+</div>
    </div>
  </div>
  `
})

const CellRenderInputSuggestion = Vue.extend({
  data() {
    return {
      value: ''
      // suggestions: [
      //   {
      //     value: 'porsche',
      //     link: 'porsche'
      //   },
      //   {
      //     value: 'mercedes',
      //     link: 'mercedes'
      //   },
      //   {
      //     value: 'toyota',
      //     link: 'toyota'
      //   }
      // ]
    }
  },
  watch: {
    // value() {
    //   this.params.context.componentParent.textInputChange(
    //     this.params,
    //     this.value
    //   )
    // }
  },
  beforeMount() {
    // if (this.params?.value) {
    //   this.value = this.params.value
    // }
  },
  mounted() {
    if (this.params.code) {
      this.value = this.params.code
    }
    this.links = this.loadAll()
  },
  methods: {
    querySearch(queryString, cb) {
      var links = this.links
      var results = queryString
        ? links.filter(this.createFilter(queryString))
        : links
      // call callback function to return suggestions
      cb(results)
    },
    createFilter(queryString) {
      return link => {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    loadAll() {
      return this.params.productSuggestionList
    },
    changeInput(data) {
      // setTimeout(() => {
      //   this.value = this.params.context.componentParent.code
      // }, 50)
      this.params.context.componentParent.suggestionInputChanged(
        this.params.rowIndex,
        data
      )
    }
  },
  template: `
  <div>
    <el-autocomplete
      class="inline-input"
      v-model="value"
      :fetch-suggestions="querySearch"
      @select="changeInput"
    >
    </el-autocomplete>
  </div>`
  // template: `<input class="input-text-border-none" type="text" v-model="value" @blur="changeInput"/>`
})

const CellRenderFullWidth = Vue.extend({
  data() {
    return {
      value: ''
    }
  },
  watch: {
    value() {
      this.params.context.componentParent.textInputChange(
        this.params,
        this.value
      )
    }
  },
  beforeMount() {
    if (this.params?.value) {
      this.value = this.params.value
    }
  },
  methods: {
    onSuggestions() {
      return [
        {
          value: 'porsche',
          link: 'https://github.com/vuejs/vue'
        },
        {
          value: 'mercedes',
          link: 'https://github.com/vuejs/vue'
        },
        {
          value: 'toyota',
          link: 'https://github.com/vuejs/vue'
        }
      ]
    }
  },
  template: `<div>Cell Render Full Width</div>`
})

const CellRenderSelectWithSearchTable = Vue.extend({
  components: {
    SelectWithSearchTable
  },
  data() {
    return {
      indexField: '',
      searchFields: [],
      rows: [],
      columns: [],
      selectedIndexFieldValue: null,
      dropdownWidth: null,
      colName: null
    }
  },
  mounted() {
    this.indexField = this.params.indexField
    this.searchFields = this.params.searchFields
    this.rows = this.params.rows || []
    this.columns = this.params.columns || []
    this.selectedIndexFieldValue = this.params.selectedIndexFieldValue
    this.dropdownWidth = this.params.dropdownWidth
    this.colName = this.params.colName
    this.scopedSlotsValue = this.params.scopedSlotsValue
  },
  methods: {
    onSelectRow(row) {
      this.params.context.componentParent.selectSearchTableChange(
        this.params,
        row,
        this.colName
      )
    }
  },
  render(h) {
    return h('div', [
      h(SelectWithSearchTable, {
        props: {
          // size: 'mini',
          dropdownWidth: this.dropdownWidth,
          indexField: this.indexField,
          selectedIndexFieldValue: this.selectedIndexFieldValue,
          rows: this.rows,
          columns: this.columns,
          searchFields: this.searchFields
        },
        on: {
          selectionChanged: this.onSelectRow
        },
        scopedSlots: {
          value: this.scopedSlotsValue
        }
      })
    ])
  }
  //  template:
  //   `
  //   <div>
  //     <SelectWithSearchTable
  //       size="mini"
  //       :dropdown-width="dropdownWidth"
  //       :index-field="indexField"
  //       :selectedIndexFieldValue="selectedIndexFieldValue"
  //       :rows="rows"
  //       :columns="columns"
  //       :search-fields="searchFields"
  //       @selectionChanged="onSelectRow"
  //     />
  //       <template v-slot:value="{ selectedValue: selectedData }">
  //         {{ selectedData?.sub_transaction_id }} {{ selectedData?.sub_transaction_desc }}
  //       </template>
  //     </SelectWithSearchTable>
  //   </div>
  //   `
})

const CellRenderCurrencyInput = Vue.extend({
  components: {
    CurrencyInput
  },
  data() {
    return {
      value: null,
      colName: null,
      readOnly: false
    }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    if (this.params.readOnly) {
      this.readOnly = this.params.readOnly
    }
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
  },
  methods: {
    changeInput() {
      this.params.context.componentParent.changeCurrencyInput(
        this.params,
        this.value,
        this.colName
      )
    },
    onClick(e) {
      e.stopPropagation()
    }
    // onInput(val) {
    //   this.value = val
    // }
  },
  template: `
    <div>
      <span v-if="readOnly" class="read-only-input-cell-render">{{Number(value).toLocaleString('en')}}</span>
      <div v-else>
        <VxCurrencyInput class="input-text-border-none" v-model="value" @blur="changeInput" @click="onClick" />
      </div>
    </div>
  `
})

const CellRenderCalendar = Vue.extend({
  components: {
    SingleCalendar
  },
  data() {
    return {
      value: null,
      colName: null
    }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
  },
  methods: {
    changeCalendar() {
      this.params.context.componentParent.changeCalendar(
        this.params,
        this.value,
        this.colName
      )
    }
    // onInput(val) {
    //   this.value = val
    // }
  },
  template: `
    <SingleCalendar
      v-model="value"
      class="use-icon"
      :date-data="value"
      @input="changeCalendar" />
  `
})

const CellRenderNumberInput = Vue.extend({
  data() {
    return {
      value: '',
      type: 'number',
      colName: null,
      textAlign: 'left'
    }
  },
  watch: {
    // value() {
    //   this.params.context.componentParent.textInputChange(
    //     this.params,
    //     this.value
    //   )
    // }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
    if (
      this.params?.textAlign !== null &&
      this.params?.textAlign !== undefined
    ) {
      this.textAlign = this.params.textAlign
    }
  },
  methods: {
    changeInput() {
      this.params.context.componentParent.textInputChange(
        this.params,
        +this.value,
        this.colName
      )
    }
  },
  template: `<input
    class="input-text-border-none"
    min='0'
    type="number"
    v-model="value"
    @blur="changeInput"
    :style="{ textAlign: textAlign }"
    onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
  />`
})

const CellRenderVxCurrencyInput = Vue.extend({
  components: {
    VxCurrencyInput
  },
  data() {
    return {
      value: null,
      colName: null
    }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
  },
  methods: {
    changeInput() {
      this.params.context.componentParent.onBlurCurrencyInput(
        this.params,
        this.value,
        this.colName
      )
    },
    onClick(e) {
      e.stopPropagation()
    },
    onInput() {
      this.params.context.componentParent.onChangeCurrencyInput(
        this.params,
        this.value,
        this.colName
      )
    },
    onFocus() {
      this.params.context.componentParent.onFocusCurrencyInput(
        this.params,
        this.value,
        this.colName
      )
    }
  },
  template: `
  <VxCurrencyInput
    v-model="value"
    class="input-text-border-none"
    @blur="changeInput"
    @click="onClick"
    @input="onInput"
    @focus="onFocus"
  />`
})
const CellRenderIconQuestion = Vue.extend({
  components: {
    IconSvg
  },
  data() {
    return {
      value: ''
    }
  },
  mounted() {},
  template: `<IconSvg style="font-size: 20px" growByHeight icon="question" />`
})

const CellRenderRowDetail = Vue.extend({
  props: {
    desc: null
  },
  template: `<h1 style="padding: 20px;">{{ desc }}</h1>`
})

const ViewInvoiceCellRender = Vue.extend({
  computed: {
    url() {
      return `/cashier/invoice?id=${
        this.params.data.sub_booking_group_id ?? ''
      }&recode=${encodeURIComponent(
        this.params.data.recode_group ?? this.params.data.recode ?? ''
      )}&name=${encodeURIComponent(
        this.params.data.customer_name ?? this.params.customer_name ?? ''
      )}&company=${encodeURIComponent(
        this.params.data.agent_name ?? ''
      )}&address=${encodeURIComponent(
        this.params.data.address ?? ''
      )}&from=${encodeURIComponent(
        this.params.data.arrive_date ?? this.params.arrive_date
      )}&to=${encodeURIComponent(
        this.params.data.depart_date ?? this.params.depart_date
      )}&isView=${true}`
    }
  },
  mounted() {
    console.log(this.params, 'check render')
  },
  template: `<a style="text-decoration: underline;" :href="url" target="_blank">{{params.data.recode_group ? params.data.recode_group : params.data.recode}}</a>`
})
const ViewInvoiceCellRenderDebtReport = Vue.extend({
  computed: {
    url() {
      return `/cashier/invoice?id=${
        this.params.data.subBookingId ?? ''
      }&recode=${encodeURIComponent(
        this.params.data.recode_group ?? ''
      )}&name=${encodeURIComponent(
        this.params.data.customer_name ?? ''
      )}&company=${encodeURIComponent(
        this.params.data.agent_name ?? ''
      )}&address=${encodeURIComponent(
        this.params.data.address ?? ''
      )}&from=${encodeURIComponent(
        this.params.data.arrive_date ?? ''
      )}&to=${encodeURIComponent(this.params.data.depart_date ?? '')}`
    }
  },
  template: `<div>
  <template v-if="params.data.subBookingId">
    <a style="text-decoration: underline; text-underline-offset: 2px; color: rgb(53 116 86); font-weight: 500" 
      :href="url" target="_blank">
      {{params.data.invoice_num}}
    </a>
  </template>
    <template v-else>{{params.data.invoice_num}}</template>
  </div>
  `
})
const HtmlCellRender = Vue.extend({
  data() {
    return {
      contents: []
    }
  },
  beforeMount() {
    this.params.contents ? (this.contents = this.params.contents) : null
  },
  mounted() {
    // this.$ref.content.innerHTML = this.content
  },
  template: `<div><p v-for="(content,index) in contents" style="margin: 0; line-height: 33px" :key='index'>{{content}}</p></div>`
})

const CellRenderUnderscoreText = Vue.extend({
  data() {
    return {
      value: '',
      type: 'text',
      colName: null
    }
  },
  mounted() {
    // console.log('bienle', this.params)
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
  },
  methods: {
    onClick() {
      this.params.context.componentParent.onClickFolio(this.params)
    }
  },
  template: `<span style="cursor: pointer; text-decoration:underline; font-size:600" @click="onClick">
  {{ value }}
</span>`
})

const CellRenderTextLink = Vue.extend({
  data() {
    return {
      value: ''
    }
  },
  mounted() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
  },
  methods: {
    onClick() {
      this.params.context.componentParent.onCellRenderTextLinkClick(this.params)
    }
  },
  template: `<span class="link-text" style="font-weight: 500" @click="onClick">
      {{ value }}
    </span>`
})

export {
  CellRenderRowDetail,
  HtmlCellRender,
  // Header
  CellHeaderAddIcon,
  // End MCI
  CellRenderCalendar,
  CellRenderCheckbox,
  CellRenderCheckboxReadonly,
  CellRenderColorPicker,
  CellRenderCurrencyInput,
  CellRenderDeleteIcon,
  CellRenderEditIcon,
  CellRenderFullWidth,
  CellRenderInputSuggestion,
  CellRenderNumberInput,
  CellRenderOpenDialogWhenCLicked,
  cellRenderParamsConfig,
  CellRenderSelect,
  CellRenderSelectWithSearchTable,
  CellRenderTextInput,
  CellRenderTextInput2,
  CellRenderDateTimeInput,
  CellRenderToggleSwitch,
  CellRenderToggleSwitchReadOnly,
  CellRenderNumberInputBySum,
  CellRenderControlNumber,
  CellRenderVxCurrencyInput,
  CellRenderIconQuestion,
  ViewInvoiceCellRender,
  ViewInvoiceCellRenderDebtReport,
  CellRenderUnderscoreText,
  CellRenderTextLink
}
